import { render, staticRenderFns } from "./OrganizeManage.vue?vue&type=template&id=cd45da0e&scoped=true"
import script from "./OrganizeManage.vue?vue&type=script&lang=js"
export * from "./OrganizeManage.vue?vue&type=script&lang=js"
import style0 from "./OrganizeManage.vue?vue&type=style&index=0&id=cd45da0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd45da0e",
  null
  
)

export default component.exports